import { connect } from 'react-redux'
import { loadData } from 'actions/rent_list_actions'

function mapStateToProps (state, props) {
  return {
    elementGroups: state.rentList?.elementGroups || {},
    groupedAvailableElements: state.rentList?.groupedAvailableElements || {},
    rentElementRequestInProgress: state.rentList?.rentElementRequestInProgress,
    rentedItems: state.rentList?.rentedItems || {},
    errors: state.rentList?.errors || [],
  }
}

function mapDispatchToProps (dispatch) {
  return {
    loadData: data => dispatch(loadData(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
